import getQuickComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getQuickComposeViewState';
import { QuickComposePivotType } from 'owa-calendar-helpers-types/lib/ComposeTypes';

export default function isOofPivotActive(): boolean {
    const activePivot = getQuickComposeViewState().activePivot;
    return activePivot === QuickComposePivotType.OOF;
}
